import React from "react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import ReactMarkdown from "react-markdown";
import { removeSourcesFooter } from "@/utils/messageFilters";

interface ChatMessageBubbleProps {
  content: string;
  senderType: "user" | "ai" | "system";
  timestamp: string;
  agentName?: string;
  agentAvatar?: string;
  brandColor?: string;
}

export const ChatMessageBubble = ({
  content,
  senderType,
  timestamp,
  agentName,
  agentAvatar,
  brandColor = "#060520",
}: ChatMessageBubbleProps) => {
  // For system messages
  if (senderType === "system") {
    return (
      <div className="text-center text-sm text-muted-foreground py-2">
        {content}
      </div>
    );
  }

  // For user messages
  if (senderType === "user") {
    return (
      <div className="flex justify-end">
        <div
          className="px-4 py-3 rounded-[7px] max-w-[80%]"
          style={{
            backgroundColor: brandColor || "#060520",
            color: "#FFFFFF",
          }}
        >
          {content}
        </div>
      </div>
    );
  }

  // For agent messages, filter out source references
  const displayContent = removeSourcesFooter(content);

  // For agent messages
  return (
    <div className="flex items-start gap-2">
      <Avatar className="h-8 w-8">
        {agentAvatar ? (
          <AvatarImage src={agentAvatar} alt={agentName || "AI"} />
        ) : (
          <AvatarFallback>{(agentName || "AI").substring(0, 2)}</AvatarFallback>
        )}
      </Avatar>
      <div className="bg-[#f2f2f2] p-3 rounded-[7px] max-w-[80%] text-black prose prose-sm border-none">
        <ReactMarkdown
          components={{
            a: ({ node, ...props }) => (
              <a {...props} target="_blank" rel="noopener noreferrer" />
            ),
          }}
        >
          {displayContent}
        </ReactMarkdown>
      </div>
    </div>
  );
};
